export { default as Map } from './Map'
export { default as Layer } from './Layer'
export { default as Popup } from './Popup'
export { default as Circle } from './Circle'
export { MapContext, withMap } from './MapContext'

export const MapMenu = props => props.children
MapMenu.displayName = 'MapMenu'
export const MapItem = props => props.children

export const MapLayer = props => props.children
MapLayer.displayName = 'MapLayer'
export const MapOverlay = props => props.children
MapOverlay.displayName = 'MapOverlay'

export const MapTabs = props => props.children
MapTabs.displayName = 'MapTabs'
export const MapTab = props => props.children

export const LayerGroup = props => props.children
LayerGroup.displayName = 'LayerGroup'
export const LayerItem = props => props.children



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/components/index.js